/** @format */

/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { getData } from '../../../../../Helpers/webApi'
import localize from '../../../../../Global/Localize'
import { formatCurrency, formatDate } from '../../../../../Helpers/formatters'
import SimpleTable from '../../../../../Components/Tables/SimpleTable'

function LoanDeductions({ loanCase }) {
  const [loan, setLoan] = useState(loanCase)
  const [fetching, setFetching] = useState(false)
  const [deductions, setDeductions] = useState([])

  async function findDeductions() {
    setFetching(true)
    const { success, data } = await getData(
      '/loanCase/find-loan-case-deductions-by-loan-case-id',
      { loanCaseId: loan?.id },
      false
    )
    if (success) {
      setFetching(false)
      setDeductions(data?.result)
    } else {
      setFetching(false)
    }
  }

  useEffect(() => {
    findDeductions()
    // eslint-disable-next-line
  }, [])

  const columns = [
    { label: localize('description'), template: r => <>{r?.description}</> },
    {
      label: localize('amount'),
      template: r => <>{formatCurrency(r?.amount)}</>,
    },
    {
      label: localize('category'),
      template: r => <>{r?.categoryDescription}</>,
    },
    {
      label: localize('fullAccountNumber'),
      template: r => <>{r?.fullAccountNumber}</>,
    },
    {
      label: localize('appUserName'),
      template: r => <>{r?.applicationUsername}</>,
    },
    {
      label: localize('envUserName'),
      template: r => <>{r?.environmentUserName}</>,
    },
    {
      label: localize('envMachineName'),
      template: r => <>{r?.environmentMachineName}</>,
    },
    {
      label: localize('envDomainName'),
      template: r => <>{r?.environmentDomainName}</>,
    },
    {
      label: localize('envOperatingSystemVersion'),
      template: r => <>{r?.environmentOSVersion}</>,
    },
    {
      label: localize('envMACAddress'),
      template: r => <>{r?.environmentMACAddress}</>,
    },
    {
      label: localize('envMotherboardSerialNumber'),
      template: r => <>{r?.environmentMotherboardSerialNumber}</>,
    },
    {
      label: localize('envProcessorId'),
      template: r => <>{r?.environmentProcessorId}</>,
    },
    {
      label: localize('envIpAddress'),
      template: r => <>{r?.environmentIPAddress}</>,
    },
    { label: localize('createdBy'), template: r => <>{r?.createdBy}</> },
    {
      label: localize('createdDate'),
      template: r => <>{formatDate(r?.createdDate)}</>,
    },
  ]

  return fetching ? (
    <div className="d-flex align-items-center justify-content-center p-5">
      <div className="spinner-border text-dark"></div>
    </div>
  ) : (
    <div>
      <SimpleTable data={deductions} columns={columns} />
    </div>
  )
}

export default LoanDeductions
